require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-will-the-idb-invest-effectively-address-harm-as-it.json") })
        }
      }, "path---en-us-update-will-the-idb-invest-effectively-address-harm-as-it");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-will-the-idb-invest-effectively-address-harm-as-it!./.cache/json/en-us-update-will-the-idb-invest-effectively-address-harm-as-it.json
// module id = 871
// module chunks = 231608221292675